<template>
  <BaseModal
    :id="id"
    :modalClass="`modal-import-data`"
    :headerText="$t('message.importlotfromexcel')"
    :showCloseButton="!isSubmitted"
    @onClose="handleClose"
  >
    <template #body>
      <div class="container-body">
        <ImportData
          v-if="isRenderContent"
          :columns="columns"
          :templateLink="templateLink"
          :invalid.sync="invalid"
          @onChange="handleChange"
        />
      </div>
    </template>
    <template #footer>
      <div class="container-footer w-100 d-flex justify-content-between align-items-center">
        <a
          href="https://treesoft.io/th/manual/inventory#lot"
          target="_blank"
        >
          {{ $t('button.learnmore') }}
          <i class="fas fa-external-link-alt"/>
        </a>
        <div>
          <!-- <button
            type="button"
            class="btn btn-light"
            @click="handleClose">
            {{ $t('button.close') }}
          </button>
          <button
            :disabled="isDisabledSaveBtn"
            type="button"
            class="btn btn-web"
            @click="handleSubmit"
          >
            {{ $t('button.save') }}
          </button> -->
          <BaseFormAction
            :textCancel="$t('button.close')"
            :textSubmit="$t('button.save')"
            :isSubmitted="isSubmitted"
            :isHideCloseButton="false"
            :isDisabledSubmit="isDisabledSaveBtn"
            @onCancel="handleClose"
            @onSubmit="handleSubmit"
          />
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import importDataMixin from '@/mixins/importData'
import { validateColumn, isValidDate, isValidNumber } from '@/helpers/validate'
import { mapGetters } from 'vuex'

export default {
  mixins: [importDataMixin],

  data () {
    return {
      templateLink: {
        name: this.$t('download.template.lot.name'),
        source: this.$t('download.template.lot.source'),
      },
      columns: [
        {
          key: 'PNAME_SKU',
          name: this.$t('column.productname'),
          type: String,
          required: true,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: (value) => { // will be called. return boolean
                let skuId = this.getSkuIdByProductName(value)
                if (skuId == null) {
                  skuId = this.getSkuIdBySkuCode(value)
                }
                if (skuId == null) {
                  return false
                }
                if (!this.isUseLot(skuId)) {
                  return false
                }
                const whId = this.getWhIdByCode(rows['WH_CODE'][rowIndex])
                if (whId) {
                  const isAssignToWh = this.isSkuAssignInWh(skuId, whId)
                  if (!isAssignToWh) {
                    return false
                  }
                }
                return true
              },
              errorMessage: this.$t('message.notfounddataincolumn', { name: columnName }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'WH_CODE',
          name: this.$t('column.whcode'),
          type: String,
          required: true,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: (value) => { // will be called. return boolean
                const whId = this.getWhIdByCode(value)
                return whId
              },
              errorMessage: this.$t('message.notfounddataincolumn', { name: columnName }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'BIN_CODE',
          name: this.$t('column.bincode'),
          type: String,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: (value) => { // will be called. return boolean
                const whCode = rows['WH_CODE'][rowIndex]
                if (whCode) {
                  const binId = this.getBinIdBy(value, whCode)
                  if (!binId) {
                    return false
                  }
                }
                return true
              },
              errorMessage: this.$t('message.notfounddataincolumn', { name: columnName }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'DATE_IN',
          name: this.$t('column.datein'),
          type: Date,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: isValidDate, // will be called. return boolean
              errorMessage: this.$t('message.thiscolumnmustbeformatdate', { name: columnName, format: 'DD/MM/YYYY' }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'DATE_PRODUCT',
          name: this.$t('column.dateproduct'),
          type: Date,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: isValidDate, // will be called. return boolean
              errorMessage: this.$t('message.thiscolumnmustbeformatdate', { name: columnName, format: 'DD/MM/YYYY' }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'DATE_EXP',
          name: this.$t('column.dateexp'),
          type: Date,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: isValidDate, // will be called. return boolean
              errorMessage: this.$t('message.thiscolumnmustbeformatdate', { name: columnName, format: 'DD/MM/YYYY' }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'UNIT_BALANCE',
          name: this.$t('column.unitbalance'),
          type: Number,
          required: true,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: isValidNumber, // will be called. return boolean
              errorMessage: this.$t('message.thiscolumnmustbenumber', { name: columnName }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'COST',
          name: this.$t('column.cost'),
          type: Number,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: isValidNumber, // will be called. return boolean
              errorMessage: this.$t('message.thiscolumnmustbenumber', { name: columnName }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'STATUS',
          name: this.$t('column.status'),
          type: String,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: (value) => { // will be called. return boolean
                return [
                  null,
                  ...this.$t('message.lotandserstatus').split(','),
                ].includes(value)
              },
              errorMessage: this.$t('message.thiscolumnmustbeonly', { name: columnName, text: [...this.$t('message.lotandserstatus').split(',')].join(', ') }),
              $t: this.$t,
            })
          },
        },
        {
          key: 'NOTE',
          name: this.$t('column.note'),
          type: String,
          required: false,
          errorMessage: (value, columnName, required, rowsSize, rows, rowIndex) => {
            return validateColumn(value, {
              columnName,
              required,
              rowsSize,
              validator: null, // validator will never called
              errorMessage: null,
              $t: this.$t,
            })
          },
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      isUseLot: 'isUseLot',
      getSkuIdByProductName: 'getSkuIdByProductName',
      getSkuIdBySkuCode: 'getSkuIdBySkuCode',
      getWhIdByCode: 'getWhIdByCode',
      isSkuAssignInWh: 'isSkuAssignInWh',
      getBinIdBy: 'getBinIdBy',
      getStockIdBy: 'getStockIdBy',
      getProductIdBySkuId: 'getProductIdBySkuId',
    }),
  },

  methods: {
    handleSubmit() {
      const data = this.form.map((item) => {
        const skuId = (() => {
          let id = this.getSkuIdByProductName(item.PNAME_SKU)
          if (id == null) id = this.getSkuIdBySkuCode(item.PNAME_SKU)
          return id
        })()
        const productId = this.getProductIdBySkuId(skuId)
        const whId = this.getWhIdByCode(item.WH_CODE)
        const stockId = this.getStockIdBy(skuId, whId)
        const binId = this.getBinIdBy(item.BIN_CODE, item.WH_CODE)
        return {
          'stock_id': stockId,
          'sku_id': skuId,
          'product_id': productId,
          'wh_id': whId,
          'bin_location_id': binId,
          'gr_id': null,
          'po_id': null,
          'date_in': item.DATE_IN
            ? this.convertDateISOString(item.DATE_IN)
            : new Date().toISOString(),
          'date_product': this.convertDateISOString(item.DATE_PRODUCT),
          'date_expire': this.convertDateISOString(item.DATE_EXP),
          'unit_init': this.convertNumber(item.UNIT_BALANCE),
          'cost': this.convertNumber(item.COST),
          'note': item.NOTE,
          'status': this.convertMapStatus(item.STATUS, this.$t('message.lotandserstatusmapping')),
        }
      })
      this.$emit('onSubmit', data, () => {
        this.reRender()
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseModalImportLot.vue